module.exports = __webpack_public_path__ + "img/ghost-shadow.b4f16bab.svg";